import { Body, Box, Image } from '@hover/blueprint';
import React from 'react';
import { animated, useTrail } from 'react-spring';
import styled from 'styled-components';

import { animationConfig } from 'src/modules/designStudio/helpers/animationConfig';
import { Button } from 'src/shared/components';

import { List } from '../List';

type Item = {
  id: string;
  name?: string;
  thumbnail: string;
};

interface ThumbnailListProps {
  title: string;
  items: Item[];
  selectedId?: string;
  onPress: (id: string) => void;
}

const IconBtn = styled(Button)<{ isSelected: boolean }>`
  background-color: transparent;
  &::after {
    position: absolute;
    display: ${({ isSelected }) => (isSelected ? 'block' : 'none')};
    content: '';
    border-radius: inherit;
    top: -4px;
    right: -4px;
    bottom: -4px;
    left: -4px;
    border: 2px solid #72aeef;
  }
`;

const ThumbnailList = ({
  onPress,
  selectedId,
  title,
  items,
}: ThumbnailListProps) => {
  const trails = useTrail(items.length, animationConfig.menuItemAnimation);

  return (
    <List title={title}>
      {trails.map((style, index) => (
        <animated.div key={items[index].id} style={style}>
          <Box
            display="grid"
            justifyItems="center"
            key={items[index].id}
            marginRight={300}
            minWidth="60px"
          >
            <Box>
              <IconBtn
                height={72}
                isSelected={selectedId === items[index].id}
                label={items[index].id}
                onPress={() => onPress(items[index].id)}
                shape="circle"
                width={72}
              >
                <Image
                  alt={items[index].name || items[index].id}
                  borderRadius="50%"
                  height="100%"
                  src={items[index].thumbnail}
                  width="100%"
                />
              </IconBtn>
            </Box>
            {items[index].name && (
              <Body marginBottom={100} marginTop={200} size={300}>
                {items[index].name}
              </Body>
            )}
          </Box>
        </animated.div>
      ))}
    </List>
  );
};

export { ThumbnailList };
